/*
 * @LastEditors: donsonwu
 * @Date: 2022-08-24 10:14:30
 * @LastEditTime: 2022-09-28 14:30:57
 * @Descripttion:
 */
import { btnGrayNormalHandle, TGDialogS ,teamInfo,pageDataChange,initShareFunc,bindShare,copyText,getCFArea,getchannelCode,nomsg,realGoodGift,closeDialog} from '../utils'
import { amsBtn } from '../AmsAndMilo/amsBtnTypeLimit'
import { teamParams } from '../AmsAndMilo/teamComm'
import { iActivityId, initFlow, wxBindPopId, preRolePopId, plat,isPage,backUrl } from './config'
import LoginService from '../AmsAndMilo/loginService'
import * as milo from '@tencent/milo-web'
import { AmsService } from '../AmsAndMilo/amsSubmit'
declare function need(path: string | Array<string>, cb: Function): any
declare function amsSubmit(actid: number, flowid: number): any

declare const CFbind

if(isPage=='H5'){
  milo.cookie.set("backUrl",backUrl,7200,"qq.com","/"); 
}
export function initPage(needSubmit: boolean = true, popMask: boolean = false) {
  if (needSubmit) {
    milo.Lottery.init({
      plat: plat,
      iActivityId:iActivityId,
      iFlowId: initFlow,
      withAreaInfo: false,
      forbidLoading: popMask || true,
      // flowConfig: {
      //   sData: sData
      // },
      onSuccess: (callbackObj) => {
        initFunction(callbackObj)
      },
      onFail: (callbackObj) => {
        // 抽奖失败事件
        if (callbackObj.iRet == '202') {
          TGDialogS(wxBindPopId)
          milo.miloAlert(callbackObj.sMsg)
        } else if (callbackObj.sMsg === '抱歉，您还没有角色，无法参与~' || callbackObj.sMsg === '抱歉，您还未拥有角色，无法参与~') {
          // 拉起来预创角
          milo.miloAlert(callbackObj.sMsg)
          TGDialogS(preRolePopId)
        } else {
          milo.miloAlert(callbackObj.sMsg)
        }
        return
      },
    }).then(lottory => {
      lottory.getGift()
    })
  } else {
    initFunction((window as any).cfhdCallbackObj[iActivityId])
  }
}

if ((window as any).cfhdCallbackObj == undefined) {
  (window as any).cfhdCallbackObj = {}
}
// ;(window as any).cfhdCallbackObj[iActivityId] = { sOutValue1: '', sOutValue2: '', sOutValue3: '', sOutValue4: '', sOutValue5: '', sOutValue6: '', sOutValue7: '', sOutValue8: '' }
// 需要开发人员手工更改  NEED-TODO
var btnClassList1: Array<amsBtn> = [
{class:'.HOLD521219_0',before:kolcfhddh,flowId:914518,key:'sOutValue1',postion:'0',params:{dmid1:1},btnStr:"已兑换"},//tab1-兑换礼_dmid1
{class:'.HOLD521219_1',flowId:914519,key:'sOutValue1',postion:'1',params:{dmid2:1}},//tab1-登录礼_dmid2
{class:'.HOLD521219_2',flowId:914530,key:'sOutValue1',postion:'2',params:{dmid15:1}},//tab2-团队人数奖励领取_dmid15
{class:'.HOLD521219_3',flowId:914530,key:'sOutValue1',postion:'3',params:{dmid15:2}},//tab2-团队人数奖励领取_dmid15
{class:'.HOLD521219_4',flowId:914530,key:'sOutValue1',postion:'4',params:{dmid15:3}},//tab2-团队人数奖励领取_dmid15
{class:'.HOLD521219_5',flowId:914531,key:'sOutValue1',postion:'5',params:{dmid16:1}},//tab2-召集币兑换奖励_dmid16
{class:'.HOLD521219_6',flowId:914531,key:'sOutValue1',postion:'6',params:{dmid16:2}},//tab2-召集币兑换奖励_dmid16
{class:'.HOLD521219_7',flowId:914531,key:'sOutValue1',postion:'7',params:{dmid16:3}},//tab2-召集币兑换奖励_dmid16
{class:'.HOLD521219_8',flowId:914531,key:'sOutValue1',postion:'8',params:{dmid16:4}},//tab2-召集币兑换奖励_dmid16
{class:'.HOLD521219_9',flowId:914531,key:'sOutValue1',postion:'9',params:{dmid16:5}},//tab2-召集币兑换奖励_dmid16
{class:'.HOLD521219_10',flowId:914531,key:'sOutValue1',postion:'10',params:{dmid16:6}},//tab2-召集币兑换奖励_dmid16
{class:'.HOLD521219_11',flowId:914531,key:'sOutValue1',postion:'11',params:{dmid16:7}},//tab2-召集币兑换奖励_dmid16
{class:'.HOLD521219_12',flowId:914531,key:'sOutValue1',postion:'12',params:{dmid16:8}},//tab2-召集币兑换奖励_dmid16
{class:'.HOLD521219_13',flowId:914531,key:'sOutValue1',postion:'13',params:{dmid16:9}},//tab2-召集币兑换奖励_dmid16
{class:'.HOLD521219_14',flowId:914531,key:'sOutValue1',postion:'14',params:{dmid16:10}},//tab2-召集币兑换奖励_dmid16
{class:'.HOLD521219_15',flowId:914531,key:'sOutValue1',postion:'15',params:{dmid16:11}},//tab2-召集币兑换奖励_dmid16
{class:'.HOLD521219_16',flowId:914531,key:'sOutValue1',postion:'16',params:{dmid16:12}},//tab2-召集币兑换奖励_dmid16
{class:'.HOLD521219_17',flowId:914531,key:'sOutValue1',postion:'17',params:{dmid16:13}},//tab2-召集币兑换奖励_dmid16
{class:'.HOLD521219_18',flowId:914531,key:'sOutValue1',postion:'18',params:{dmid16:14}},//tab2-召集币兑换奖励_dmid16
{class:'.HOLD521219_19',flowId:914531,key:'sOutValue1',postion:'19',params:{dmid16:15}},//tab2-召集币兑换奖励_dmid16
{class:'.HOLD521219_20',flowId:914531,key:'sOutValue1',postion:'20',params:{dmid16:16}},//tab2-召集币兑换奖励_dmid16
{class:'.HOLD521219_21',flowId:914531,key:'sOutValue1',postion:'21',params:{dmid16:17}},//tab2-召集币兑换奖励_dmid16
{class:'.HOLD521219_22',flowId:914532,key:'sOutValue1',postion:'22',params:{dmid17:1}},//tab2-团队第1领奖励(次月领取)_dmid17
{class:'.HOLD521219_23',flowId:914532,key:'sOutValue1',postion:'23',params:{dmid17:2}},//tab2-团队第1领奖励(次月领取)_dmid17
{class:'.HOLD521219_24',flowId:914532,key:'sOutValue1',postion:'24',params:{dmid17:3}},//tab2-团队第1领奖励(次月领取)_dmid17
{class:'.HOLD521219_25',flowId:914532,key:'sOutValue1',postion:'25',params:{dmid17:4}},//tab2-团队第1领奖励(次月领取)_dmid17
{class:'.HOLD521219_26',flowId:914532,key:'sOutValue1',postion:'26',params:{dmid17:5}},//tab2-团队第1领奖励(次月领取)_dmid17
{class:'.HOLD521219_27',flowId:914532,key:'sOutValue1',postion:'27',params:{dmid17:6}},//tab2-团队第1领奖励(次月领取)_dmid17
{class:'.HOLD521219_28',flowId:914532,key:'sOutValue1',postion:'28',params:{dmid17:7}},//tab2-团队第1领奖励(次月领取)_dmid17
{class:'.HOLD521219_29',flowId:914532,key:'sOutValue1',postion:'29',params:{dmid17:8}},//tab2-团队第1领奖励(次月领取)_dmid17
{class:'.HOLD521219_30',flowId:914532,key:'sOutValue1',postion:'30',params:{dmid17:9}},//tab2-团队第1领奖励(次月领取)_dmid17
{class:'.HOLD521219_31',flowId:914536,key:'sOutValue1',postion:'31',params:{dmid18:1}},//tab3-大咖挑战礼_dmid18（次月领取）
{class:'.HOLD521219_32',flowId:914537,key:'sOutValue1',postion:'32',params:{dmid19:1}},//tab3-大咖认证礼_dmid19
{class:'.HOLD521219_33',flowId:914537,key:'sOutValue1',postion:'33',params:{dmid19:2}},//tab3-大咖认证礼_dmid19
{class:'.HOLD521219_34',flowId:914538,key:'sOutValue1',postion:'34',params:{dmid20:1}},//tab3-排行榜奖励领取(总榜)_dmid20
{class:'.HOLD521219_35',flowId:914538,key:'sOutValue1',postion:'35',params:{dmid20:2}},//tab3-排行榜奖励领取(总榜)_dmid20
{class:'.HOLD521219_36',flowId:914538,key:'sOutValue1',postion:'36',params:{dmid20:3}},//tab3-排行榜奖励领取(总榜)_dmid20
{class:'.HOLD521219_37',flowId:914538,key:'sOutValue1',postion:'37',params:{dmid20:4}},//tab3-排行榜奖励领取(总榜)_dmid20
{class:'.HOLD521219_38',flowId:914539,key:'sOutValue1',postion:'38',params:{dmid21:1}},//tab3-排行榜奖励领取(新回榜)_dmid21
{class:'.HOLD521219_39',flowId:914539,key:'sOutValue1',postion:'39',params:{dmid21:2}},//tab3-排行榜奖励领取(新回榜)_dmid21
{class:'.HOLD521219_40',flowId:914539,key:'sOutValue1',postion:'40',params:{dmid21:3}},//tab3-排行榜奖励领取(新回榜)_dmid21
{class:'.HOLD521219_41',flowId:914539,key:'sOutValue1',postion:'41',params:{dmid21:4}},//tab3-排行榜奖励领取(新回榜)_dmid21
{class:'.HOLD521219_42',flowId:914540,key:'sOutValue1',postion:'42',params:{dmid22:1}},//tab3-排行榜奖励领取(CF新回榜)_dmid22
{class:'.HOLD521219_43',flowId:914540,key:'sOutValue1',postion:'43',params:{dmid22:2}},//tab3-排行榜奖励领取(CF新回榜)_dmid22
{class:'.HOLD521219_44',flowId:914540,key:'sOutValue1',postion:'44',params:{dmid22:3}},//tab3-排行榜奖励领取(CF新回榜)_dmid22
{class:'.HOLD521219_45',flowId:914540,key:'sOutValue1',postion:'45',params:{dmid22:4}},//tab3-排行榜奖励领取(CF新回榜)_dmid22
{class:'.HOLD521219_46',flowId:914541,key:'sOutValue1',postion:'46',params:{dmid23:1}},//tab3-排行榜手办奖励领取_dmid23
{class:'.HOLD521219_47',before:CFfunb,flowId:914542,key:'sOutValue1',postion:'47',params:{dmid24:1}},//排行榜奖励领取（cf拉回新）_dmid24
{class:'.HOLD521219_48',before:CFfunb,flowId:914542,key:'sOutValue1',postion:'48',params:{dmid24:2}},//排行榜奖励领取（cf拉回新）_dmid24
{class:'.HOLD521219_49',before:CFfunb,flowId:914542,key:'sOutValue1',postion:'49',params:{dmid24:3}},//排行榜奖励领取（cf拉回新）_dmid24
{class:'.HOLD521219_50',before:CFfunb,flowId:914542,key:'sOutValue1',postion:'50',params:{dmid24:4}},//排行榜奖励领取（cf拉回新）_dmid24
{class:'.HOLD521219_51',before:kolbcfhddh,flowId:914546,key:'sOutValue1',postion:'51',params:{dmid25:1},btnStr:"已兑换"},//tab1-兑换B站礼_dmid25
{class:'.HOLD521219_52',flowId:914550,key:'sOutValue1',postion:'52',params:{dmid27:1}},//tab3-排行榜qb奖励领取_dmid27
{class:'.HOLD521219_53',flowId:914551,key:'sOutValue1',postion:'53',params:{dmid28:1}},//tab3-排行榜蝴蝶刀奖励领取_dmid28

{class:'.NOHOLD521219_1',flowId:914525,needInitSubmit:true,customMsg:'恭喜您成功生成KOL口令码~'},//tab1-生成大咖码
{class:'.NOHOLD521219_2',flowId:914526,needInitSubmit:true},//tab2-创建队伍
{class:'.NOHOLD521219_3',flowId:914527,before:getTeamid,needInitSubmit:true},//tab2-加入队伍-修改新回判定条件
{class:'.NOHOLD521219_4',flowId:914528,needInitSubmit:true,resolve:nomsg},//tab2-换一批
{class:'.NOHOLD521219_5',flowId:914529,needInitSubmit:true},//tab2-成为推荐团
{class:'.NOHOLD521219_6',flowId:914533,needInitSubmit:true},//tab2-累计游戏领召集币-修改条件
{class:'.NOHOLD521219_7',flowId:914534,needInitSubmit:true},//tab2-累计游戏4天领召集币-修改条件
{class:'.NOHOLD521219_8',flowId:914535,needInitSubmit:true},//tab2-消耗召集币抽奖
{class:'.NOHOLD521219_9',flowId:914545,before:getNameAndChannel,customMsg:'创建成功~'},//预创角



{class:'.HOLD521977_58',flowId:916724,config: {iActivityId: 521977,giftId: 523432},params:{dmid21:1}},//tab4回归玩家6选3_dmid21
{class:'.HOLD521977_59',flowId:916724,config: {iActivityId: 521977,giftId: 523432},params:{dmid21:2}},//tab4回归玩家6选3_dmid21
{class:'.HOLD521977_60',flowId:916724,config: {iActivityId: 521977,giftId: 523432},params:{dmid21:3}},//tab4回归玩家6选3_dmid21
{class:'.HOLD521977_61',flowId:916724,config: {iActivityId: 521977,giftId: 523432},params:{dmid21:4}},//tab4回归玩家6选3_dmid21
{class:'.HOLD521977_62',flowId:916724,config: {iActivityId: 521977,giftId: 523432},params:{dmid21:5}},//tab4回归玩家6选3_dmid21
{class:'.HOLD521977_63',flowId:916724,config: {iActivityId: 521977,giftId: 523432},params:{dmid21:6}},//tab4回归玩家6选3_dmid21
{class:'.HOLD521977_64',flowId:916730,config: {iActivityId: 521977,giftId: 523432},params:{dmid22:1}},//tab4回归元旦登录6选1_dmid22
{class:'.HOLD521977_65',flowId:916730,config: {iActivityId: 521977,giftId: 523432},params:{dmid22:2}},//tab4回归元旦登录6选1_dmid22
{class:'.HOLD521977_66',flowId:916730,config: {iActivityId: 521977,giftId: 523432},params:{dmid22:3}},//tab4回归元旦登录6选1_dmid22
{class:'.HOLD521977_67',flowId:916730,config: {iActivityId: 521977,giftId: 523432},params:{dmid22:4}},//tab4回归元旦登录6选1_dmid22
{class:'.HOLD521977_68',flowId:916730,config: {iActivityId: 521977,giftId: 523432},params:{dmid22:5}},//tab4回归元旦登录6选1_dmid22
{class:'.HOLD521977_69',flowId:916730,config: {iActivityId: 521977,giftId: 523432},params:{dmid22:6}},//tab4回归元旦登录6选1_dmid22
{class:'.HOLD521977_72',flowId:917072,config: {iActivityId: 521977,giftId: 523432},params:{dmid25:1},needInitSubmit:true},//tab4回玩家游戏3选1_dmid25
{class:'.HOLD521977_73',flowId:917072,config: {iActivityId: 521977,giftId: 523432},params:{dmid25:2},needInitSubmit:true},//tab4回玩家游戏3选1_dmid25
{class:'.HOLD521977_74',flowId:917072,config: {iActivityId: 521977,giftId: 523432},params:{dmid25:3},needInitSubmit:true},//tab4回玩家游戏3选1_dmid25
{class:'.HOLD521977_75',flowId:917073,resolve:closeDialog,config: {iActivityId: 521977,giftId: 523432},params:{dmid26:1},customMsg:'成功开启续约提醒~'},//tab4邮件同意授权_dmid26 
{class:'.HOLD521977_76',flowId:917074,resolve:closeDialog,config: {iActivityId: 521977,giftId: 523432},params:{dmid27:1},customMsg:'取消成功~'},//tab4邮件取消授权_dmid27 
{class:'.HOLD521977_77',flowId:917075,config: {iActivityId: 521977,giftId: 523432},params:{dmid28:1}},//tab4-累计登录领奖励_dmid28_修改条件登录放开
{class:'.HOLD521977_78',flowId:917075,config: {iActivityId: 521977,giftId: 523432},params:{dmid28:2}},//tab4-累计登录领奖励_dmid28_修改条件登录放开
{class:'.HOLD521977_79',flowId:917075,config: {iActivityId: 521977,giftId: 523432},params:{dmid28:3}},//tab4-累计登录领奖励_dmid28_修改条件登录放开
{class:'.HOLD521977_80',flowId:917075,config: {iActivityId: 521977,giftId: 523432},params:{dmid28:4}},//tab4-累计登录领奖励_dmid28_修改条件登录放开
{class:'.HOLD521977_81',flowId:917075,config: {iActivityId: 521977,giftId: 523432},params:{dmid28:5}},//tab4-累计登录领奖励_dmid28_修改条件登录放开
{class:'.HOLD521977_82',flowId:917075,config: {iActivityId: 521977,giftId: 523432},params:{dmid28:6}},//tab4-累计登录领奖励_dmid28_修改条件登录放开
{class:'.HOLD521977_83',flowId:917200,config: {iActivityId: 521977,giftId: 523432},params:{dmid29:1}},//tab4-每日任务领奖励_dmid29
{class:'.HOLD521977_84',flowId:917200,config: {iActivityId: 521977,giftId: 523432},params:{dmid29:2}},//tab4-每日任务领奖励_dmid29
{class:'.HOLD521977_85',flowId:917200,config: {iActivityId: 521977,giftId: 523432},params:{dmid29:3}},//tab4-每日任务领奖励_dmid29
{class:'.HOLD521977_86',flowId:917205,config: {iActivityId: 521977,giftId: 523432},params:{dmid30:1}},//tab4-成功分享领_dmid30

{class:'.HOLD521977_89',flowId:917209,config: {iActivityId: 521977,giftId: 523432},params:{dmid33:1}},//tab5新玩家3选3_dmid33
{class:'.HOLD521977_90',flowId:917209,config: {iActivityId: 521977,giftId: 523432},params:{dmid33:2}},//tab5新玩家3选3_dmid33
{class:'.HOLD521977_91',flowId:917209,config: {iActivityId: 521977,giftId: 523432},params:{dmid33:3}},//tab5新玩家3选3_dmid33
{class:'.HOLD521977_92',flowId:917210,config: {iActivityId: 521977,giftId: 523432},params:{dmid34:1}},//tab5新玩家登录6选1_dmid34
{class:'.HOLD521977_93',flowId:917210,config: {iActivityId: 521977,giftId: 523432},params:{dmid34:2}},//tab5新玩家登录6选1_dmid34
{class:'.HOLD521977_94',flowId:917210,config: {iActivityId: 521977,giftId: 523432},params:{dmid34:3}},//tab5新玩家登录6选1_dmid34
{class:'.HOLD521977_95',flowId:917210,config: {iActivityId: 521977,giftId: 523432},params:{dmid34:4}},//tab5新玩家登录6选1_dmid34
{class:'.HOLD521977_96',flowId:917210,config: {iActivityId: 521977,giftId: 523432},params:{dmid34:5}},//tab5新玩家登录6选1_dmid34
{class:'.HOLD521977_97',flowId:917210,config: {iActivityId: 521977,giftId: 523432},params:{dmid34:6}},//tab5新玩家登录6选1_dmid34
{class:'.HOLD521977_98',flowId:917211,config: {iActivityId: 521977,giftId: 523432},params:{dmid35:1},needInitSubmit:true},//tab5新家游戏3选1_dmid35
{class:'.HOLD521977_99',flowId:917211,config: {iActivityId: 521977,giftId: 523432},params:{dmid35:2},needInitSubmit:true},//tab5新家游戏3选1_dmid35
{class:'.HOLD521977_100',flowId:917211,config: {iActivityId: 521977,giftId: 523432},params:{dmid35:3},needInitSubmit:true},//tab5新家游戏3选1_dmid35
{class:'.HOLD521977_101',flowId:917212,resolve:closeDialog,config: {iActivityId: 521977,giftId: 523432},params:{dmid36:1},customMsg:'成功开启续约提醒~'},//tab5邮件同意授权_dmid36
{class:'.HOLD521977_102',flowId:917213,resolve:closeDialog,config: {iActivityId: 521977,giftId: 523432},params:{dmid37:1},customMsg:'取消成功~'},//tab5邮件取消授权_dmid37 
{class:'.HOLD521977_103',flowId:917214,config: {iActivityId: 521977,giftId: 523432},params:{dmid38:1}},//tab5-累计登录领奖励_dmid38_修改条件登录放开
{class:'.HOLD521977_104',flowId:917214,config: {iActivityId: 521977,giftId: 523432},params:{dmid38:2}},//tab5-累计登录领奖励_dmid38_修改条件登录放开
{class:'.HOLD521977_105',flowId:917214,config: {iActivityId: 521977,giftId: 523432},params:{dmid38:3}},//tab5-累计登录领奖励_dmid38_修改条件登录放开
{class:'.HOLD521977_106',flowId:917214,config: {iActivityId: 521977,giftId: 523432},params:{dmid38:4}},//tab5-累计登录领奖励_dmid38_修改条件登录放开
{class:'.HOLD521977_107',flowId:917214,config: {iActivityId: 521977,giftId: 523432},params:{dmid38:5}},//tab5-累计登录领奖励_dmid38_修改条件登录放开
{class:'.HOLD521977_108',flowId:917214,config: {iActivityId: 521977,giftId: 523432},params:{dmid38:6}},//tab5-累计登录领奖励_dmid38_修改条件登录放开
{class:'.HOLD521977_109',flowId:917215,config: {iActivityId: 521977,giftId: 523432},params:{dmid39:1}},//tab5-每日任务领奖励_dmid39
{class:'.HOLD521977_110',flowId:917215,config: {iActivityId: 521977,giftId: 523432},params:{dmid39:2}},//tab5-每日任务领奖励_dmid39
{class:'.HOLD521977_111',flowId:917215,config: {iActivityId: 521977,giftId: 523432},params:{dmid39:3}},//tab5-每日任务领奖励_dmid39
{class:'.HOLD521977_112',flowId:917217,config: {iActivityId: 521977,giftId: 523432},params:{dmid40:1}},//tab5-成功分享领_dmid40

{class:'.NOHOLD521977_8',flowId:917204,config: {iActivityId: 521977,giftId: 523432},params:{sEncrypt:milo.request('sEncrypt')}},//tab4接受邀请-游戏条件放开
{class:'.NOHOLD521977_9',flowId:917216,config: {iActivityId: 521977,giftId: 523432},params:{sEncrypt:milo.request('sEncrypt')}},//tab5接受邀请-游戏条件放开

]

export const allBtn = [...btnClassList1]
export const amsService = new AmsService(allBtn) // amsService.allBtnPromise.get(890999).then((res) => { res.getGift() })可以这样调用, 也可以在别的页面应用amsService去调动

const dataPosition= ['loginNum','gameweek','gameAndloginNum']
let pcUrl = 'https://cfhd.cf.qq.com/cp/a20230101rlr/index.html'
let h5Url = 'https://cfhd.cf.qq.com/cp/a20230101rlr/m.html'
let pagtInitStatus = 0;
let tab1Share:any;
let tab2Share:any;
let tab2TeamId:string;
let myKOLcode:string;
let area = 0;

// 初始化成功回调

// 需要开发人员手工更改  NEED-TODO
export function initFunction(callbackObj) {
  ;(window as any).cfhdCallbackObj[iActivityId] = callbackObj
  // 按钮置灰
  btnGrayNormalHandle((window as any).cfhdCallbackObj[iActivityId], allBtn, 'gray')
  // 页面数据处理
  pageDataChange((window as any).cfhdCallbackObj[iActivityId].sOutValue3,dataPosition)
  const DataArr = callbackObj.sOutValue3.split(',')
  
  myKOLcode = callbackObj.sOutValue2==0?'':callbackObj.sOutValue2;
  $(".MYKOLCODE").val(myKOLcode);

  const sylist = callbackObj.sOutValue4.split(',');
  for(let i=0;i<sylist.length; i++){
    if(sylist[i]<1){
      $(".sfsy_"+i).text("当前剩余:否");
    }else{
      $(".sfsy_"+i).text("当前剩余:是");
    }
  }

  const tab2Team = {
    teamInfo:(window as any).cfhdCallbackObj[iActivityId].sOutValue8,
    //teamInfo:'7c4kwQAkQwM4MwgM8z,1,1,3,4,1,5,6||1u0kMAggQQgA4wMg3v|5,1u0kwMMwkgkggQA42m|5,1u0M4ggwwgAA0ww41g|5,1u0MgwkAw0wkgAwA2m|5,1u0MM4Mk4gwwMMwA1g|5',
    joinClass:".tab2_team",
    notJoinClass:".dont_join_team",
    teamIdClass:".team_id",
    tjBtnClass:".tuijiantuan",
    teamCountClass:".team_count",
    teamLevelJfName:"teamCoinNum",
    jbpTeamLevelJfName:"",
    peopleLevelJfName:"myCoinNum",
    jbpPeopleLevelJfName:"",
    sypeopleLevelJfName:"mysyCoinNum",
    tjTeamListClass:".replaceBatchTeam"
  }
  tab2TeamId = teamInfo(tab2Team);

  if(pagtInitStatus==0){

    

    $("#phb_zb").html('');
    $("#phb_mjdkb").html('');
    $("#phb_zbphb").html('');
    $("#phb_cflhxphb").html('');
    $("#phb_lhxphb").html('');
    phbList('zb'); 

    pcUrl += '?sEncrypt=' + callbackObj.sOutValue6
    h5Url += '?sEncrypt=' + callbackObj.sOutValue6

    ;(window as any).tab1Share=initShareFunc(pcUrl+'&ctypeId=1',h5Url+'&ctypeId=1','免费领取 稀有皮肤','来领海量礼包福利，我在CFHD等你！','来领海量礼包福利，我在CFHD等你！','https://game.gtimg.cn/images/cfhd/cp/a20230101mact/share3.jpg',{width:224,height:224,class:'#tab1-ewm'},'share');
    bindShare(pcUrl+'&ctypeId=1',{pcBtnClass: '.fxhy1',h5BtnClass: '.fxh51',zoneBtnClass: '.fxqq1',copyBtnClass: '.fxcp1',inputValClass: '#t1copytext'},(window as any).tab1Share);

    ;(window as any).tab2Share=initShareFunc(pcUrl+'&ctypeId=2',h5Url+'&ctypeId=2','免费领取 稀有皮肤','来领海量礼包福利，我在CFHD等你！','来领海量礼包福利，我在CFHD等你！','https://game.gtimg.cn/images/cfhd/cp/a20230101mact/share2.jpg',{width:224,height:224,class:'#tab2-ewm'},'share');
    bindShare(pcUrl+'&ctypeId=2',{pcBtnClass: '.fxhy2',h5BtnClass: '.fxh52',zoneBtnClass: '.fxqq2',copyBtnClass: '.fxcp2',inputValClass: '#t2copytext'},(window as any).tab2Share);

    if (milo.request('sEncrypt') && milo.request('sEncrypt') != callbackObj.sOutValue6) {
      if(milo.request('ctypeId') == 1){
          TGDialogS('pop3');//TAB1-接受邀请 
      }else if(milo.request('ctypeId') == 2){
          TGDialogS('pop4');//TAB2-接受邀请
      }
    }

    if(callbackObj.sOutValue7>0){
      let listarr = {1:'AK-47 山海经-九尾狐',2:'GALIL 山海经',3:'M4A1 WeGame专属',4:'AWM PINK',5:'SCAR LIGHT 海洋之心',6:'R5 RGP 炫黄蜂巢'};
      $(".hsdj").text(listarr[callbackObj.sOutValue7]);
      if(callbackObj.sOutValue7>3){
        $(".HOLD5219771_101").attr('href',"javascript:TGDialogS('pop7')");
      }else{
        $(".HOLD5219771_75").attr('href',"javascript:TGDialogS('pop5')");			
      }
     }
    
    if(callbackObj.sOutValue5==1){
      $(".btntab2").addClass('on').siblings().removeClass('on');
			$(".tab").eq(1).show().siblings().hide()
    }else if(callbackObj.sOutValue5==3){
      $(".btntab3").addClass('on').siblings().removeClass('on');
			$(".tab").eq(2).show().siblings().hide()
    }
    if(isPage == 'nq'){
      $("#realaddr").bind("click",function(){alert('抱歉，请前往https://cfhd.cf.qq.com/cp/a20230101rlr/index.html填写实物地址！')});
    }else{
      $("#realaddr").bind("click",function(){realGoodGift(521219, 914516)});
    }
    pagtInitStatus = 1
  }
  
}
////排行榜奖励领取成功提示
function lqmsg(callbackObj,ele){
  if(ele.postion == 36){
    milo.miloAlert("恭喜您获得了礼包：大咖主播总榜第1-10名奖励");
  }else if(ele.postion == 39){
    milo.miloAlert("恭喜您获得了礼包：邀请回归/新用户榜第1-10名奖励");
  }else if(ele.postion == 42){
    milo.miloAlert("恭喜您获得了礼包：CF拉新/回榜第1-10名奖励");
  }else{
    milo.miloAlert(callbackObj.sMsg);
  }
}

//执行传CF大区的方法
function CFfunb(ele){
  if(area>0){
    ;(window as any)[`sData${ele.class}`].area = area
    return true;
  }else{
    CFbind.initbind('myarea','bindarea()')
    return false;
  }
}
//绑定cf大区
function bindarea() {
  if (CFbind.CFareaid > 0) {
    area = CFbind.CFareaid    
    // if (isPage == 'H5') {
    //   $('#myarea').text(CFbind.CFareaname)
    // } else {
    //   $('#myarea').text(CFbind.CFareaname + ' ' + CFbind.CFername)
    // }
    milo.miloAlert('绑定大区成功')
    closeDialog()
  } else {
    milo.miloAlert('在该服务器上未获取到角色信息！')
  }
}
//查看排行榜
function phbList(ptype){
  LoginService(isPage).checkAndLogin().then(() => {
    amsPromise.then((lottery) => {
      lottery.getGift()
    })
  })
  
  const amsPromise = milo.Lottery.init({
    plat: plat,
    iActivityId:  iActivityId,
    iFlowId: 914544,
    withAreaInfo: false,
    forbidLoading: false,
    flowConfig: {
      sData: {
        'bdtype':ptype
      }
    },
    onSuccess: (res) => {
			let zphbarr = res.jData.sortData;
			let zhtml = '<tr><th>排名</th><th>主播名</th><th>QQ号</th><th>邀请数</th></tr>';
      let dkname='';
			for (let i=0;i<zphbarr.length ;i++ ){
				if(zphbarr[i]['sTVcode'] == 'cfdk' || zphbarr[i]['sTVcode'] == 'cfhddk' ){
					dkname = resetqq(decodeURIComponent(zphbarr[i]['sKOLname']));
				}else{
					dkname = zphbarr[i]['sKOLname'];
				}
					zhtml += '<tr>\
										<td>'+zphbarr[i]['rank']+'</td>\
										<td>'+dkname+'</td>\
										<td>'+resetqq(zphbarr[i]['iUin'])+'</td>\
										<td>'+zphbarr[i]['iNum']+'</td>\
								</tr>';	
			}
			$("#phb_"+ptype).html(zhtml);
    },
    onFail: (err) => {
      console.log(err)
    },
  })
}

//加入团队
function joinTeam(tid){
  LoginService(isPage).checkAndLogin().then(() => {
    amsPromise.then((lottery) => {
      lottery.getGift()
    })
  })
  
  const amsPromise = milo.Lottery.init({
    plat: plat,
    iActivityId:  iActivityId,
    iFlowId: 914527,
    withAreaInfo: false,
    forbidLoading: false,
    flowConfig: {
      sData: {
        'team_id':tid
      }
    },
    onSuccess: (res) => {
      console.log(res)
      milo.miloAlert("加团成功~")
      initPage()
    },
    onFail: (err) => {
      milo.miloAlert(err.sMsg)
    },
  })
}


//购买
function djcbuy() {
  LoginService(isPage)
  .checkAndLogin()
  .then((check) => {
    amsSubmit(521219,914523)
  }) 
  
}

;(window as any).amsCfg_914523 = {
  'iActivityId' : '521219',
  'iFlowId' : '906288',
  'sData'	: {'sArea':600},
  '_everyRead': true, //_everyRead参数用于控制缓存，设为true表示每次发请求都会读取amsCfg参数的值，建议加上
  'fFlowSubmitEnd': function(res) {
    need(["ams.daoju_buy_svr.daoju_buy_svr"], function(DaojuBuy) {
      var option = {
        //apptype:4	新版webpay，已默认
        onPaySuccess:function(){
          //$(".38buy").addClass('gray').text('已购买')
        },//支付成功后回调方法
        //onPayClose:function(){}//关闭支付页面回调方法
      };
      DaojuBuy.svrPay(res.jData,option);
    });
  }, 
  'fFlowSubmitFailed':function(res) {
    milo.miloAlert(res.sMsg);
  }
};


//kol奖励兑换
function kolcfhddh(ele) {
  let kolcode = $(".kol-input").val();
  if(kolcode==''){
    milo.miloAlert("请先输入兑换码~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].kolcode = kolcode
  return true;
}

//kol奖励兑换
function kolcfhddh2(ele) {
  let kolcode2 = $(".kol-input2").val();
  if(kolcode2==''){
    milo.miloAlert("请先输入兑换码~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].kolcode = kolcode2
  return true;
}
//kolb站奖励兑换
function kolbcfhddh(ele) {
  let bkolcode = $(".bkolcode").val();
  if(bkolcode==''){
    milo.miloAlert("请先输入兑换码~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].bkolcode = bkolcode
  return true;
}

//kolb站奖励兑换
function kolbcfhddh2(ele) {
  let bkolcode2 = $(".bkolcode2").val();
  if(bkolcode2==''){
    milo.miloAlert("请先输入兑换码~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].bkolcode = bkolcode2
  return true;
}

function getTeamid(ele){
  let teamid = $(".teamID").val();  
  if(teamid==''){
    milo.miloAlert("请填写要加入的团队ID~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].team_id = teamid
  return true;
}


function creatTjList(callbackObj,ele){
  var teamList = callbackObj.jData.list.split(',')
  console.log(teamList)
  var domstr1 = ''
  teamList.forEach(function (teamInfo) {
    if (teamInfo != '') {
      var team = teamInfo.split('|')
      domstr1 += '<tr><td>' + team[0] + '</td><td>' + team[1] + '</td></tr>'
    }
  })  

  $('.tab2_team_list').empty()
  $('.tab2_team_list').append(domstr1)
}


function getNameAndChannel(ele){
  let preNickName = $(".preNickName").val()
  if(preNickName==''){
    milo.miloAlert("请填写角色名称~")
    return false;
  }
  let urlInfo = window.location.href.split('/');
  if(urlInfo[5]=='qd'){ 
    var hkChannel = getchannelCode(6)
  }else{
    var hkChannel = getchannelCode(5)
  }
  
  if(hkChannel==undefined){
    milo.miloAlert("抱歉，不是允许的渠道~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].preNickName = preNickName
  ;(window as any)[`sData${ele.class}`].hkChannel = hkChannel
  return true;
}

var channelItemArr = {
  hy: 1,
  djc: 2,
  gj: 3,
  llq: 4,
  wegame: 5,
  wegames: 5,
  hyh5: 1,
  djch5: 2
}
/*$('.widget').click(function () {
  channelJob()
})*/
function getChannelItem(ele) {
  let urlInfo = window.location.href.split('/');
  var urlArr = urlInfo[6].split('.')
  var Channelid = channelItemArr[urlArr[0]]
  if (!Channelid) {
    milo.miloAlert('渠道错误~')
    return false;
  }
  ;(window as any)[`sData${ele.class}`].dmidqd = Channelid
  return true;

}


function copyTeamId(){
  if(tab2TeamId){
    copyText(tab2TeamId,milo.miloAlert("复制成功~"));
  }else{
    milo.miloAlert("抱歉请先加入团队再来复制哦~")
  }
}
function copyKOLId(){
  if(myKOLcode){
    copyText(myKOLcode,milo.miloAlert("复制成功~"));
  }else{
    milo.miloAlert("抱歉请先生成大咖码再来复制哦~")
  }
}
//屏蔽中间4位数字
function resetqq(qq) {
  var str = String(qq)
  var len = str.length;
  if (len >= 7) {
    var reg = str.slice(-7, -3)
    return str.replace(reg, "****")
  } else if (len < 7 && len >= 6) {
    //1234567
    var reg = str.slice(-4, -2)
    return str.replace(reg, "**")
  } else if (len < 6 && len >= 4) {
    //1234567
    var reg = str.slice(-2, -1)
    return str.replace(reg, "**")
  }else{
	return 	str;
  }
}

//地址跳转  todo
// function jumpCfActive() {
//   let jumpLink = 'https://cf.qq.com/act/8861/a20221018rlr/lr/index.shtml';
//   if(isPage=='H5'){
//     jumpLink = 'https://cf.qq.com/act/8861/a20221018rlr/lr/h5/h5.shtml';
//   }
//   window.location.href = jumpLink
// }
//云游戏跳转
function yunGame() {
  if(isPage == 'H5'){
    milo.miloAlert('请去官网参加')
  }else{
      window.location.href = 'https://imgcdn.start.qq.com/cdn/win.client/installer/publish/START-installer-cfhd-1010.exe';
  }
}
;(window as any).kolcfhddh = kolcfhddh
;(window as any).kolcfhddh = kolcfhddh2
;(window as any).kolcfhddh = kolbcfhddh
;(window as any).kolcfhddh = kolbcfhddh2
;(window as any).djcbuy = djcbuy
;(window as any).copyTeamId = copyTeamId
;(window as any).copyKOLId = copyKOLId
;(window as any).phbList = phbList
;(window as any).joinTeam = joinTeam
;(window as any).resetqq = resetqq
;(window as any).yunGame = yunGame
;(window as any).bindarea = bindarea 